/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Event_Templates_Delete_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to delete template: {error}" |
*
* @param {Event_Templates_Delete_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_delete_failed_toast = /** @type {((inputs: Event_Templates_Delete_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Delete_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la suppression du modele: ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Vorlage konnte nicht gelöscht werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile eliminare il modello: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось удалить шаблон: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo eliminar la plantilla: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`删除模板失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`テンプレートの削除に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टेम्प्लेट को हटाने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao excluir o modelo: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to delete template: ${i?.error}`)
});